/**
 * This component adds overlay in the passed element to open color picker in a popover
 *
 * @author Afifa Saleem <afifa@250mils.com>
 */

import React from 'react';
import './color-picker-popover.scss';
import {ColorPicker} from "../color-picker";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {ModalFooterPrimaryAction} from "../modal-deprecated/components/modal-footer-primary-action";
import PropTypes from "prop-types";
import {Icon} from "@Components/icon-v2";
import {IconSize} from "@Components/icon-v2/icon.types";

const SCREEN_SIZE = {
    BIG: 'big',
    SMALL: 'small'
};

export default class ColorPickerPopover extends React.Component {
    #color = '';

    constructor(props) {
        super(props);
    }

    /**
     * Render the modal component
     * @return {JSX.Element}
     */
    render = () => {
        return (
            <OverlayTrigger
                {...this.props}
                trigger="click"
                rootClose
                delay={{show: 500, hide: 0}}
                overlay={
                    <Tooltip id={"colorpicker-popover-" + this.props.screen}
                             className={this.props.placement}
                             onClick={this.#popperClicked}>
                        {this.#getHeader()}
                        {this.#getContent()}
                        {this.#getFooter()}
                    </Tooltip>
                }
            >
                <span id={'color-popper-' + this.props.selectedColor} className={'color-picker-overlay'}>
                    {this.props.iconName && <Icon icon={this.props.iconName} size={IconSize.SIZE_ICON_24}/>}
                </span>
            </OverlayTrigger>
        );
    };

    /**
     * @return {JSX.Element}
     */
    #getContent = () => {
        return (
            <ColorPicker
                initialColors={this.props.initialColors}
                inputColorSwatch={this.props.inputColorSwatch}
                showBrandColors={this.props.showBrandColors}
                onColorChanged={this.#onColorChange}
                onColorChanging = {this.#onColorChange}
            />
        );
    };

    /**
     * @return {JSX.Element}
     */
    #getHeader = () => {
        if (this.props.screen === SCREEN_SIZE.SMALL) {
            return (
                <div className={'facnytext-modal-header'}>
                    <div className={'body-xs-bold'}>
                        {i18next.t('pmwjs_color_picker')}
                    </div>
                    <span>
                        <i className={'icon icon-close action-icon'}
                           onClick={this.#closeModal}/>
                    </span>
                </div>
            );
        }
    };

    /**
     * @return {JSX.Element}
     */
    #getFooter = () => {
        if (this.props.screen === SCREEN_SIZE.SMALL) {
            return (
                <ModalFooterPrimaryAction customClasses={'-fullwidth spacing-m-t-3 spacing-m-b-3'} text={i18next.t('pmwjs_btn_apply')} onClick={this.#onApplyColor}/>
            );
        }
    };

    /**
     * Handler for when color is changed from color picker
     */
    #onColorChange = (color) => {
        this.#color = color;
        if (this.props.screen === SCREEN_SIZE.BIG) {
            this.props.onColorChanged(color);
        }
    };

    /**
     * Handler for Footer action button
     */
    #onApplyColor = () => {
        this.props.onColorChanged(this.#color);
        this.#closeModal();
    };

    /**
     * close the popover if clicked outside the color picker popover
     */
    #closeModal = () => {
        let selector = '#color-popper-'+this.props.selectedColor;
        $(selector).trigger('click');
    };

    /**
     * close button handler
     */
    #popperClicked = (e) => {
        if ($(e.target).hasClass('tooltip')) {
            this.#closeModal()
        }
    };
}

ColorPickerPopover.propTypes = {
    /**
     * The first color for picker
     */
    initialColors: PropTypes.array.isRequired,

    /**
     * on which direction overlay should open (right, left, top, bottom)
     */
    placement: PropTypes.string.isRequired,

    /**
     * optional bool that is used to add a color swatch in hex input field
     */
    inputColorSwatch: PropTypes.bool,

    /**
     * used as an id for overlay
     */
    selectedColor: PropTypes.string.isRequired,

    /**
     * screen size info (small, big)
     */
    screen: PropTypes.string,

    /**
     * a handler that invokes when the color is being updated
     */
    onColorChanged: PropTypes.func.isRequired,

    /**
     * optional bool to show brand colors in color picker component
     */
    showBrandColors: PropTypes.bool,

    /**
     * optional, to show icon in color selector
     */
    iconName: PropTypes.string
};
